const styleCss = {
  font: { sz: "11" },
  border: {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  },
  alignment: {
    // wrapText: true,
    horizontal: "center",
    vertical: "top",
  },
};

const styleMainHeaderCss = {
  font: { sz: "13", bold: true, color: { rgb: "1d428a" } },
  alignment: {
    // wrapText: true,
    horizontal: "left",
    vertical: "top",
  },
};

const styleColumnHeaderCss = {
  fill: {
    patternType: "solid",
    fgColor: { rgb: "e6eefb" },
  },
  font: { sz: "11", bold: true, color: { rgb: "1d428a" } },
  border: {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  },
  alignment: {
    // wrapText: true,
    horizontal: "center",
    vertical: "top",
  },
};

const aligmentCss = {
  // wrapText: true,
  horizontal: "center",
  vertical: "top",
};

const columns = {
  PlayerProfile: {
    CombineDetails1: [
      {
        title: "Participation Type",
        width: 200,
      },
      {
        title: "Jersey Number",
        width: 200,
      },
    ],
    CombineDetails2: [
      {
        title: "Date of Birth",
        width: 200,
      },
      {
        title: "Twitter",
        width: 200,
      },
      {
        title: "Instagram",
        width: 200,
      },
      {
        title: "Height",
        width: 200,
      },
      {
        title: "Position",
        width: 200,
      },
      {
        title: "Weight",
        width: 200,
      },
      {
        title: "Residence",
        width: 200,
      },
    ],
    AgentDetails: [
      {
        title: "Agency Name/Agent",
        field: "name",
        width: 200,
      },
      {
        title: "Agent Phone",
        field: "phone",
        width: 200,
      },
      {
        title: "Agent Email",
        field: "email",
        width: 200,
      },
      // {
      //   title: "Player Number",
      //   field: "playerNumber",
      //   width: 200,
      // },
      // {
      //   title: "Player Email",
      //   field: "playerEmail",
      //   width: 200,
      // },
    ],
    CollegeExperience: [
      {
        title: "College Class",
        field: "classTypeName",
        width: 150,
      },
      {
        title: "College Year",
        field: "years",
        width: 150,
      },
      {
        title: "College",
        field: "collegeName",
        width: 150,
      },
      {
        title: "College Conference",
        field: "conferenceName",
        width: 180,
      },
      {
        title: "College Contact",
        field: "contact",
        width: 150,
      },
      {
        title: "College Contact Phone",
        field: "phone",
        width: 190,
      },
      {
        title: "College Contact Email",
        field: "email",
        width: 190,
      },
    ],
    HighSchoolDetails: [
      {
        title: "High School Year",
        field: "years",
        width: 150,
      },
      {
        title: "High School",
        field: "schoolName",
        width: 150,
      },
      {
        title: "High School Town/City",
        field: "townOrCity",
        width: 190,
      },
      {
        title: "High School State",
        field: "state",
        width: 180,
      },
      {
        title: "High School Contact",
        field: "contact",
        width: 190,
      },
      {
        title: "High School Contact Phone",
        field: "phone",
        width: 220,
      },
      {
        title: "High School Contact Email",
        field: "email",
        width: 200,
      },
    ],
    AAUClubPrograms: [
      // {
      //   title: "AAU/Club Location",
      //   field: "location",
      //   width: 180,
      // },
      {
        title: "AAU Circuit",
        field: "circuit",
        width: 150,
      },
      {
        title: "AAU/Club Programs",
        field: "programs",
        width: 180,
      },
      {
        title: "AAU/Club Programs Contact",
        field: "programsContact",
        width: 230,
      },
      {
        title: "AAU/Club Programs Contact Phone",
        field: "programsPhone",
        width: 280,
      },
      {
        title: "AAU/Club Programs Contact Email",
        field: "programsEmail",
        width: 280,
      },
    ],
    ProfessionalExperience: [
      {
        title: "Club Year",
        field: "years",
        width: 150,
      },
      {
        title: "Country of Club",
        field: "countryName",
        width: 150,
      },
      {
        title: "League",
        field: "league",
        width: 150,
      },
      {
        title: "Club",
        field: "clubName",
        width: 150,
      },
      {
        title: "Club Contact",
        field: "contact",
        width: 150,
      },
      {
        title: "Club Contact Phone",
        field: "phone",
        width: 180,
      },
    ],
    GLeagueExperience: [
      {
        title: "G League Year",
        field: "years",
        width: 150,
      },
      {
        title: "Team",
        field: "team",
        width: 150,
      },
      {
        title: "Team Contact",
        field: "contact",
        width: 150,
      },
      {
        title: "Team Contact Phone",
        field: "phone",
        width: 180,
      },
    ],
    InternationalTeamExperience: [
      {
        title: "International Experience Year",
        field: "expYear",
        width: 250,
      },
      {
        title: "International Experience Country",
        field: "countryName",
        width: 250,
      },
      {
        title: "International Experience",
        field: "experience",
        width: 200,
      },
    ],
    HighSchoolEvents: [
      {
        title: "Event Name",
        width: 200,
      },
      {
        title: "Year",
        width: 200,
      },
    ],
    Rankings: [
      {
        title: "Event Name",
        width: 200,
      },
      {
        title: "Ranking",
        width: 200,
      },
    ],
  },
  PlayerCareerStats: {
    PlayerDetails: [
      {
        title: "Name",
        width: 200,
      },
      {
        title: "College or Club",
        width: 200,
      },
      {
        title: "Team",
        width: 200,
      },
      {
        title: "Birth Place",
        width: 200,
      },
    ],
    CareerBasicStats: [
      {
        title: "Season Year",
        field: "seasonYear",
        width: 200,
      },
      {
        title: "Height",
        field: "height",
        width: 200,
      },
      {
        title: `Weight`,
        field: "weight",
        width: 200,
      },
      {
        title: `Position`,
        field: "position",
        width: 200,
      },
      {
        title: `Jersey#`,
        field: "jerseyNumber",
        width: 200,
      },
      {
        title: `Experience`,
        field: "experience",
        width: 200,
      },
      {
        title: `GP`,
        field: "gamesPlayed",
        width: 200,
      },
      {
        title: `GS`,
        field: "gamesStarted",
        width: 200,
      },
      {
        title: `Min`,
        field: "minutes",
        width: 200,
      },
      {
        title: `FGM`,
        field: "fieldGoalsMade",
        width: 200,
      },
      {
        title: `FGA`,
        field: "fieldGoalsAtt",
        width: 200,
      },
      {
        title: `FG%`,
        field: "fieldGoalsPct",
        width: 200,
      },
      {
        title: `2PM`,
        field: "twoPointsMade",
        width: 200,
      },
      {
        title: `2PA`,
        field: "twoPointsAtt",
        width: 200,
      },
      {
        title: `2P%`,
        field: "twoPointsPct",
        width: 200,
      },
      {
        title: `3PM`,
        field: "threePointsMade",
        width: 200,
      },
      {
        title: `3PA`,
        field: "threePointsAtt",
        width: 200,
      },
      {
        title: `3P%`,
        field: "threePointsPct",
        width: 200,
      },
      {
        title: `FTM`,
        field: "freeThrowsMade",
        width: 200,
      },
      {
        title: `FTA`,
        field: "freeThrowsAtt",
        width: 200,
      },
      {
        title: `FT%`,
        field: "freeThrowsPct",
        width: 200,
      },
      {
        title: `ORB`,
        field: "offensiveRebounds",
        width: 200,
      },
      {
        title: `DRB`,
        field: "defensiveRebounds",
        width: 200,
      },
      {
        title: `REB`,
        field: "rebounds",
        width: 200,
      },
      {
        title: `AST`,
        field: "assists",
        width: 200,
      },
      {
        title: `TO`,
        field: "turnovers",
        width: 200,
      },
      {
        title: `STL`,
        field: "steals",
        width: 200,
      },
      {
        title: `BLK`,
        field: "blocks",
        width: 200,
      },
      {
        title: `PF`,
        field: "personalFouls",
        width: 200,
      },
      {
        title: `TF`,
        field: "techFouls",
        width: 200,
      },
      {
        title: `PTS`,
        field: "points",
        width: 200,
      },
      {
        title: `FF`,
        field: "flagrantFouls",
        width: 200,
      },
      {
        title: `TS%`,
        field: "trueShootingPct",
        width: 200,
      },
    ],
    CareerAdvancedStats: [
      {
        title: "Season Year",
        field: "seasonYear",
        width: 200,
      },
      {
        title: "TS%",
        field: "tS_Pct",
        width: 200,
      },
      {
        title: `eFG%`,
        field: "eFG_Pct",
        width: 200,
      },
      {
        title: `3PA`,
        field: "threePAr",
        width: 200,
      },
      {
        title: `FTr`,
        field: "fTr",
        width: 200,
      },
      {
        title: `ORB%`,
        field: "orB_Pct",
        width: 200,
      },
      {
        title: `DRB%`,
        field: "drB_Pct",
        width: 200,
      },
      {
        title: `TRB%`,
        field: "trB_Pct",
        width: 200,
      },
      {
        title: `AST%`,
        field: "asT_Pct",
        width: 200,
      },
      {
        title: `STL%`,
        field: "stL_Pct",
        width: 200,
      },
      {
        title: `BLK%`,
        field: "blK_Pct",
        width: 200,
      },
      {
        title: `TOV%`,
        field: "toV_Pct",
        width: 200,
      },
      {
        title: `USG%`,
        field: "usG_Pct",
        width: 200,
      },
      {
        title: `ORtg`,
        field: "oRtg",
        width: 200,
      },
      {
        title: `DRtg`,
        field: "dRtg",
        width: 200,
      },
    ],
  },
  Anthropometry: [
    {
      title: "Standing Reach (ft & in)",
      width: 200,
    },
    {
      title: "Wingspan (ft & in)",
      width: 200,
    },
    // {
    //   title: "Height (w/ shoes) (ft & in)",
    //   width: 200,
    // },
    {
      title: "Height (w/o shoes) (ft & in)",
      width: 200,
    },
    {
      title: "Body Weight (lbs)",
      width: 200,
    },
    {
      title: "Hand Width Inches",
      width: 200,
    },
    {
      title: "Hand Length Inches",
      width: 200,
    },
    {
      title: "Body Fat Percentage",
      width: 200,
    },
    {
      title: "DEXA Body Fat Percentage",
      width: 200,
    },
  ],
  AnthropometryKgFeetInches: [
    {
      title: "Standing Reach (ft & in)",
      width: 200,
    },
    {
      title: "Wingspan (ft & in)",
      width: 200,
    },
    // {
    //   title: "Height (w/ shoes) (ft & in)",
    //   width: 200,
    // },
    {
      title: "Height (w/o shoes) (ft & in)",
      width: 200,
    },
    {
      title: "Body Weight (kg)",
      width: 200,
    },
    {
      title: "Hand Width Inches",
      width: 200,
    },
    {
      title: "Hand Length Inches",
      width: 200,
    },
    {
      title: "Body Fat Percentage",
      width: 200,
    },
    {
      title: "DEXA Body Fat Percentage",
      width: 200,
    },
  ],
  AnthropometryKgInches: [
    {
      title: "Standing Reach (in)",
      width: 200,
    },
    {
      title: "Wingspan (in)",
      width: 200,
    },
    // {
    //   title: "Height (w/ shoes) (in)",
    //   width: 200,
    // },
    {
      title: "Height (w/o shoes) (in)",
      width: 200,
    },
    {
      title: "Body Weight (kg)",
      width: 200,
    },
    {
      title: "Hand Width Inches",
      width: 200,
    },
    {
      title: "Hand Length Inches",
      width: 200,
    },
    {
      title: "Body Fat Percentage",
      width: 200,
    },
    {
      title: "DEXA Body Fat Percentage",
      width: 200,
    },
  ],
  AnthropometryKgCentiMeter: [
    {
      title: "Standing Reach (cm)",
      width: 200,
    },
    {
      title: "Wingspan (cm)",
      width: 200,
    },
    // {
    //   title: "Height (w/ shoes) (cm)",
    //   width: 200,
    // },
    {
      title: "Height (w/o shoes) (cm)",
      width: 200,
    },
    {
      title: "Body Weight (kg)",
      width: 200,
    },
    {
      title: "Hand Width (cm)",
      width: 200,
    },
    {
      title: "Hand Length (cm)",
      width: 200,
    },
    {
      title: "Body Fat Percentage",
      width: 200,
    },
    {
      title: "DEXA Body Fat Percentage",
      width: 200,
    },
  ],
  AnthropometryKgMeter: [
    {
      title: "Standing Reach (m)",
      width: 200,
    },
    {
      title: "Wingspan (m)",
      width: 200,
    },
    // {
    //   title: "Height (w/ shoes) (m)",
    //   width: 200,
    // },
    {
      title: "Height (w/o shoes) (m)",
      width: 200,
    },
    {
      title: "Body Fat Percentage",
      width: 200,
    },
    {
      title: "DEXA Body Fat Percentage",
      width: 200,
    },
    {
      title: "Hand Width (m)",
      width: 200,
    },
    {
      title: "Hand Length (m)",
      width: 200,
    },
    {
      title: "Body Weight (kg)",
      width: 200,
    },
  ],
  AnthropometryGramFeetInches: [
    {
      title: "Standing Reach (ft & in)",
      width: 200,
    },
    {
      title: "Wingspan (ft & in)",
      width: 200,
    },
    // {
    //   title: "Height (w/ shoes) (ft & in)",
    //   width: 200,
    // },
    {
      title: "Height (w/o shoes) (ft & in)",
      width: 200,
    },
    {
      title: "Body Weight (g)",
      width: 200,
    },
    {
      title: "Hand Width Inches",
      width: 200,
    },
    {
      title: "Hand Length Inches",
      width: 200,
    },
    {
      title: "Body Fat Percentage",
      width: 200,
    },
    {
      title: "DEXA Body Fat Percentage",
      width: 200,
    },
  ],
  AnthropometryGramInches: [
    {
      title: "Standing Reach (in)",
      width: 200,
    },
    {
      title: "Wingspan (in)",
      width: 200,
    },
    // {
    //   title: "Height (w/ shoes) (in)",
    //   width: 200,
    // },
    {
      title: "Height (w/o shoes) (in)",
      width: 200,
    },
    {
      title: "Body Weight (g)",
      width: 200,
    },
    {
      title: "Hand Width Inches",
      width: 200,
    },
    {
      title: "Hand Length Inches",
      width: 200,
    },
    {
      title: "Body Fat Percentage",
      width: 200,
    },
    {
      title: "DEXA Body Fat Percentage",
      width: 200,
    },
  ],
  AnthropometryGramCentiMeter: [
    {
      title: "Standing Reach (cm)",
      width: 200,
    },
    {
      title: "Wingspan (cm)",
      width: 200,
    },
    // {
    //   title: "Height (w/ shoes) (cm)",
    //   width: 200,
    // },
    {
      title: "Height (w/o shoes) (cm)",
      width: 200,
    },
    {
      title: "Body Weight (g)",
      width: 200,
    },
    {
      title: "Hand Width (cm)",
      width: 200,
    },
    {
      title: "Hand Length (cm)",
      width: 200,
    },
    {
      title: "Body Fat Percentage",
      width: 200,
    },
    {
      title: "DEXA Body Fat Percentage",
      width: 200,
    },
  ],
  AnthropometryGramMeter: [
    {
      title: "Standing Reach (m)",
      width: 200,
    },
    {
      title: "Wingspan (m)",
      width: 200,
    },
    // {
    //   title: "Height (w/ shoes) (m)",
    //   width: 200,
    // },
    {
      title: "Height (w/o shoes) (m)",
      width: 200,
    },
    {
      title: "Body Weight (gm)",
      width: 200,
    },
    {
      title: "Hand Width (m)",
      width: 200,
    },
    {
      title: "Hand Length (m)",
      width: 200,
    },
    {
      title: "Body Fat Percentage",
      width: 200,
    },
    {
      title: "DEXA Body Fat Percentage",
      width: 200,
    },
  ],
  AnthropometryLbsInches: [
    {
      title: "Standing Reach (in)",
      width: 200,
    },
    {
      title: "Wingspan (in)",
      width: 200,
    },
    // {
    //   title: "Height (w/ shoes) (in)",
    //   width: 200,
    // },
    {
      title: "Height (w/o shoes) (in)",
      width: 200,
    },
    {
      title: "Body Weight (lbs)",
      width: 200,
    },
    {
      title: "Hand Width Inches",
      width: 200,
    },
    {
      title: "Hand Length Inches",
      width: 200,
    },
    {
      title: "Body Fat Percentage",
      width: 200,
    },
    {
      title: "DEXA Body Fat Percentage",
      width: 200,
    },
  ],
  AnthropometryLbsCentiMeter: [
    {
      title: "Standing Reach (cm)",
      width: 200,
    },
    {
      title: "Wingspan (cm)",
      width: 200,
    },
    // {
    //   title: "Height (w/ shoes) (cm)",
    //   width: 200,
    // },
    {
      title: "Height (w/o shoes) (cm)",
      width: 200,
    },
    {
      title: "Body Weight (lbs)",
      width: 200,
    },
    {
      title: "Hand Width (cm)",
      width: 200,
    },
    {
      title: "Hand Length (cm)",
      width: 200,
    },
    {
      title: "Body Fat Percentage",
      width: 200,
    },
    {
      title: "DEXA Body Fat Percentage",
      width: 200,
    },
  ],
  AnthropometryLbsMeter: [
    {
      title: "Standing Reach (m)",
      width: 200,
    },
    {
      title: "Wingspan (m)",
      width: 200,
    },
    // {
    //   title: "Height (w/ shoes) (m)",
    //   width: 200,
    // },
    {
      title: "Height (w/o shoes) (m)",
      width: 200,
    },
    {
      title: "Body Weight (lbs)",
      width: 200,
    },
    {
      title: "Hand Width (m)",
      width: 200,
    },
    {
      title: "Hand Length (m)",
      width: 200,
    },
    {
      title: "Body Fat Percentage",
      width: 200,
    },
    {
      title: "DEXA Body Fat Percentage",
      width: 200,
    },
  ],

  StrengthAndAgility: {
    ShuttleRun: [
      {
        title: "Shuttle Run Left Trial Time (s)",
        width: 200,
      },
      {
        title: "Shuttle Run Left Laser Time (s)",
        width: 200,
      },
      {
        title: "Shuttle Run Right Trial Time (s)",
        width: 200,
      },
      {
        title: "Shuttle Run Right Laser Time (s)",
        width: 200,
      },
    ],
    Verticals: [
      {
        title: "Max Vertical (in)",
        width: 200,
      },
      {
        title: "Standing Vertical (in)",
        width: 200,
      },
    ],
    VerticalsToCentimeter: [
      {
        title: "Max Vertical (cm)",
        width: 200,
      },
      {
        title: "Standing Vertical (cm)",
        width: 200,
      },
    ],
    VerticalsToMeter: [
      {
        title: "Max Vertical (m)",
        width: 200,
      },
      {
        title: "Standing Vertical (m)",
        width: 200,
      },
    ],
    ProLane: [
      {
        title: "Pro Lane Trial Time (s)",
        width: 200,
      },
      {
        title: "Pro Lane Total Laser Time (s)",
        width: 200,
      },
    ],
    ProLanePosition: [
      {
        title: "Position",
        width: 200,
      },
      {
        title: "1",
        width: 200,
      },
      {
        title: "2",
        width: 200,
      },
      {
        title: "3",
        width: 200,
      },
      {
        title: "4",
        width: 200,
      },
      {
        title: "5",
        width: 200,
      },
      {
        title: "6",
        width: 200,
      },
      {
        title: "7",
        width: 200,
      },
      {
        title: "8",
        width: 200,
      },
    ],
    ThreeFour: [
      {
        title: "3/4 Court Sprint Time (s)",
        width: 200,
      },
      {
        title: "3/4 Court Sprint Total Laser Time (s)",
        width: 200,
      },
    ],
    ThreeFourPosition: [
      {
        title: "Position",
        width: 200,
      },
      {
        title: "1",
        width: 200,
      },
      {
        title: "2",
        width: 200,
      },
      {
        title: "3",
        width: 200,
      },
      {
        title: "4",
        width: 200,
      },
    ],
  },
  ShootingDrills: {
    ShootingDrillsOverallSummary: [
      {
        title: "Shooting Drill",
        width: 200,
      },
      {
        title: "Result",
        width: 200,
      },
      {
        title: "Percentage",
        width: 200,
      },
    ],
    ShootingDrillRegion: [
      {
        title: "Region",
        width: 200,
      },
      {
        title: "Result",
        width: 200,
      },
      {
        title: "Percentage",
        width: 200,
      },
    ],
  },
};

module.exports = {
  styleCss,
  styleMainHeaderCss,
  styleColumnHeaderCss,
  aligmentCss,
  columns,
};
